<div class="mat-dialog-camera-view">
    <div mat-dialog-title class="dialog-title">
        <h2>{{headerName}}</h2>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
            <div class="cockpit-iframe">
                <iframe [src]="safeIframeUrl" frameborder="0" width="100%" height="100%"></iframe>
            </div>
    </mat-dialog-content>      
</div>